import { FunctionComponent } from 'react';
import styled from 'styled-components';

import { body1, colors, spacing, heading4 } from 'ui/theme';
import { PredictiveGoalsSpinner } from './Styled';
import { TEST_IDS } from '../constants';

const ContentUnavailableParentContainer = styled.div`
  border: ${spacing.single} solid ${colors.grey5};
  border-radius: ${spacing.half};
  position: relative;
`;

const ContentUnavailableContentContainer = styled.div`
  filter: blur(6px);
`;

const ContentUnavailableContainer = styled.div`
  align-items: center;
  background-color: rgb(255 255 255 / 0.7);
  border-radius: ${spacing.half};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index: 2;
`;

const ContentUnavailableHeader = styled.h4`
  ${heading4}
`;

const ContentUnavailableBody = styled.p`
  ${body1}
  color: ${colors.textSecondary};
`;

export type ContentUnavailableProps = {
  bodyMessage?: string;
  headerMessage?: string;
  showPlaceholderContent?: boolean;
};
export const ContentUnavailable: FunctionComponent<
  React.PropsWithChildren<ContentUnavailableProps>
> = ({ bodyMessage, children, headerMessage, showPlaceholderContent, ...props }) => {
  if (!showPlaceholderContent) {
    return <>{children}</>;
  }
  return (
    <ContentUnavailableParentContainer {...props}>
      <ContentUnavailableContainer data-test={TEST_IDS.DataUnavailable}>
        <PredictiveGoalsSpinner />
        <ContentUnavailableHeader>{headerMessage}</ContentUnavailableHeader>
        <ContentUnavailableBody>{bodyMessage}</ContentUnavailableBody>
      </ContentUnavailableContainer>
      <ContentUnavailableContentContainer>{children}</ContentUnavailableContentContainer>
    </ContentUnavailableParentContainer>
  );
};
